/* jh-help.js: behaviour for the three help pages (Contact, Track your order, Withdraw), one shared script.
   Every page works without it: Contact and Withdraw show all their steps stacked and post normally; Track says it needs
   JavaScript. This script adds the one step at a time flow, the progress rail, the error style, and the requests.
   All visible words come from the section settings, through the JSON block [data-hp-config] the section prints.
   Server data (order titles, tracking numbers, messages) is escaped before it goes into HTML; a tracking link is used only if it is https. */
(function () {
  'use strict';
  var root = document.querySelector('[data-help]');
  if (!root) return;
  var cfgEl = root.querySelector('script[data-hp-config]');
  var CFG = {};
  try { CFG = JSON.parse(cfgEl ? cfgEl.textContent : '{}'); } catch (e) { CFG = {}; }
  var T = CFG.t || {};
  var PAGE = root.getAttribute('data-help');
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var wide = window.matchMedia('(min-width: 1024px)');

  function $(s, c) { return (c || root).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || root).querySelectorAll(s)); }
  function icon(n) { return '<svg class="hp-ico" aria-hidden="true" focusable="false"><use href="#hp-i-' + n + '"/></svg>'; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  /* Fill {tokens} in a setting. The setting text is escaped; the values are trusted HTML the caller built. */
  function fill(tpl, map) { return esc(tpl).replace(/\{(\w+)\}/g, function (m, k) { return Object.prototype.hasOwnProperty.call(map, k) ? map[k] : m; }); }
  function plain(tpl, map) { return String(tpl).replace(/\{(\w+)\}/g, function (m, k) { return Object.prototype.hasOwnProperty.call(map, k) ? map[k] : m; }); }
  function mailLink() { return '<a class="hp-link hp-mail" href="mailto:' + esc(T.mail) + '">' + esc(T.mail) + '</a>'; }
  function fmtDate(iso, withTime) {
    var d = new Date(iso); if (isNaN(d)) return '';
    var o = { day: 'numeric', month: 'long', year: 'numeric', timeZone: 'Europe/Lisbon' };
    if (withTime) { o.hour = '2-digit'; o.minute = '2-digit'; o.hour12 = false; }
    return new Intl.DateTimeFormat('en-GB', o).format(d);
  }
  function fmtTime(iso) {
    var d = new Date(iso); if (isNaN(d)) return '';
    return new Intl.DateTimeFormat('en-GB', { hour: '2-digit', minute: '2-digit', hour12: false, timeZone: 'Europe/Lisbon' }).format(d);
  }
  function post(url, body) {
    return fetch(url, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
      .then(function (res) { return res.json().catch(function () { return {}; }).then(function (j) { return { status: res.status, ok: res.ok, j: j || {} }; }); });
  }

  /* ---------- the one error style: bar, icon and words under the field, an error list above, aria-invalid on the controls ---------- */
  function ctrls(f) { return $$('input:not([type=hidden]):not([disabled]), textarea:not([disabled])', f); }
  function clearErr(f) {
    f.classList.remove('is-invalid');
    var p = f.querySelector(':scope > .hp-err');
    ctrls(f).forEach(function (i) {
      i.removeAttribute('aria-invalid');
      if (p) {
        var d = (i.getAttribute('aria-describedby') || '').split(' ').filter(function (x) { return x && x !== p.id; }).join(' ');
        if (d) i.setAttribute('aria-describedby', d); else i.removeAttribute('aria-describedby');
      }
    });
    if (p) p.remove();
  }
  function setErr(f, msg) {
    clearErr(f);
    f.classList.add('is-invalid');
    var id = f.id + '-err', p = document.createElement('p');
    p.className = 'hp-err'; p.id = id;
    p.innerHTML = icon('warn') + '<span>' + esc(msg) + '</span>';
    f.appendChild(p);
    ctrls(f).forEach(function (i) {
      i.setAttribute('aria-invalid', 'true');
      i.setAttribute('aria-describedby', ((i.getAttribute('aria-describedby') || '') + ' ' + id).trim());
    });
  }
  function val(f) {
    if (f.querySelector('input[type=radio]')) { var r = f.querySelector('input[type=radio]:checked'); return r ? r.value : ''; }
    var i = f.querySelector('input:not([type=hidden]), textarea');
    return i ? i.value.trim() : '';
  }
  function firstCtrl(f) { return f.querySelector('input:not([type=hidden]):not([disabled]), textarea:not([disabled])'); }
  function errSummary(container, bad) {
    var old = container.querySelector(':scope .hp-errsum'); if (old) old.remove();
    if (!bad.length) return;
    var box = document.createElement('div');
    box.className = 'hp-errsum'; box.setAttribute('role', 'alert');
    box.innerHTML = '<p class="hp-errsum__t">' + esc(T.summaryTitle || '') + '</p><ul>' + bad.map(function (f) {
      return '<li><a href="#' + esc(f.id) + '" data-goto-field="' + esc(f.id) + '">' + esc(f.getAttribute('data-err-now') || '') + '</a></li>';
    }).join('') + '</ul>';
    container.insertBefore(box, container.firstChild);
  }
  function validate(container) {
    var bad = [];
    $$('[data-req]', container).forEach(function (f) {
      if (f.closest('[hidden]')) return;
      clearErr(f);
      var v = val(f), msg = null;
      if (!v) msg = f.getAttribute('data-err');
      else if (f.getAttribute('data-type') === 'email' && !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v)) msg = f.getAttribute('data-err-format');
      if (msg) { f.setAttribute('data-err-now', msg); setErr(f, msg); bad.push(f); }
    });
    var body = container.querySelector('.hp-step__body') || container;
    errSummary(body, bad);
    if (bad.length) { var c = firstCtrl(bad[0]); if (c) c.focus(); }
    return bad.length === 0;
  }
  document.addEventListener('input', function (e) { var f = e.target.closest && e.target.closest('.hp-field.is-invalid'); if (f) { clearErr(f); dropFromSummary(f); } });
  document.addEventListener('change', function (e) { var f = e.target.closest && e.target.closest('.hp-field.is-invalid'); if (f) { clearErr(f); dropFromSummary(f); } });
  function dropFromSummary(f) {
    var a = root.querySelector('.hp-errsum a[data-goto-field="' + f.id + '"]');
    if (!a) return;
    var li = a.closest('li'), box = a.closest('.hp-errsum'); li.remove();
    if (!box.querySelector('li')) box.remove();
  }
  root.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-goto-field]'); if (!a) return;
    e.preventDefault();
    var f = document.getElementById(a.getAttribute('data-goto-field')), c = f && firstCtrl(f);
    if (c) c.focus();
  });
  function alertBox(kind, title, bodyHtml) {
    return '<div class="hp-alert' + (kind === 'info' ? ' hp-alert--info' : '') + '" role="' + (kind === 'info' ? 'status' : 'alert') + '">' + icon(kind === 'info' ? 'info' : 'warn') + '<div><p class="hp-alert__t">' + esc(title) + '</p><p class="hp-alert__b">' + bodyHtml + '</p></div></div>';
  }
  function bringIntoView(el) {
    var r = el.getBoundingClientRect();
    if (r.top < 0 || r.top > window.innerHeight * 0.6) el.scrollIntoView({ block: 'start', behavior: reduce ? 'auto' : 'smooth' });
  }
  /* The status region stays in the DOM and only its text changes, so screen readers announce it. */
  function setBusy(btn, busy, on) {
    var spin = busy.querySelector('.hp-spin'), txt = busy.querySelector('[data-busy-text]');
    if (on) btn.setAttribute('aria-disabled', 'true'); else btn.removeAttribute('aria-disabled');
    busy.classList.toggle('is-on', !!on);
    if (spin) spin.hidden = !on;
    if (txt) txt.textContent = on ? (busy.getAttribute('data-text') || '') : '';
  }

  /* ---------- the one progress indicator: number, name and "Step x of y" in words, never colour alone ---------- */
  function renderSteps(nav, steps, cur, names, answers, onGo) {
    if (!nav) return;
    var ol = $('[data-steps]', nav), now = $('[data-prog-now]', nav);
    var i = steps.indexOf(cur), n = steps.length;
    nav.style.setProperty('--n', n);
    nav.setAttribute('data-cur', cur);
    ol.innerHTML = steps.map(function (s, k) {
      var st = k < i ? 'done' : (k === i ? 'now' : 'next');
      var node = '<span class="hp-steps__n" aria-hidden="true">' + (st === 'done' ? icon('check') : '<span>' + (k + 1) + '</span>') + '</span>';
      var title = '<span class="hp-steps__t">' + esc(names[s]) + '</span>';
      var sr = '<span class="hp-vh">, ' + (st === 'done' ? esc(T.rowDone || 'done') : (st === 'now' ? esc(T.rowNow || 'this step') : esc(T.rowNext || 'still to do'))) + '</span>';
      var ans = answers[s] ? '<span class="hp-steps__a">' + esc(answers[s]) + '</span>' : '';
      var inner;
      if (st === 'done') inner = '<button type="button" class="hp-steps__btn" data-go="' + esc(s) + '">' + node + title + sr + ans + '<span class="hp-steps__chg">' + esc(T.rowChange || 'Change') + '</span></button>';
      else inner = '<span class="hp-steps__btn">' + node + title + sr + (st === 'now' ? '<span class="hp-steps__tag" aria-hidden="true">' + esc(T.rowNowTag || 'Now') + '</span>' : '') + '</span>';
      return '<li class="hp-steps__i is-' + st + '"' + (st === 'now' ? ' aria-current="step"' : '') + '>' + inner + '</li>';
    }).join('');
    now.innerHTML = esc(plain(T.stepOf || 'Step {n} of {total}', { n: i + 1, total: n })) + '<span class="hp-prog__name">' + esc(names[cur]) + '</span>';
    $$('[data-go]', ol).forEach(function (b) { b.addEventListener('click', function () { onGo(b.getAttribute('data-go')); }); });
  }
  function stepNames(form) {
    var o = {};
    $$('.hp-step', form).forEach(function (s) { o[s.getAttribute('data-step')] = s.getAttribute('data-name') || ''; });
    return o;
  }

  /* Generic stepper shared by Contact and Withdraw. opts: form, flow, nav, list(), answers(), onShow(step), validateStep */
  function stepper(o) {
    var form = o.form, names = stepNames(form), cur = o.first;
    function render() { renderSteps(o.nav, o.list(), cur, names, o.answers(), function (s) { show(s, true); }); }
    function show(step, focus) {
      cur = step;
      var list = o.list(), k = list.indexOf(step);
      $$('.hp-step', form).forEach(function (s) { s.hidden = s.getAttribute('data-step') !== step; });
      if (o.onShow) o.onShow(step);
      $$('[data-stepno]', form).forEach(function (x) { x.textContent = plain(T.stepOf || 'Step {n} of {total}', { n: k + 1, total: list.length }) + ': '; });
      render();
      var old = form.querySelector('.hp-errsum'); if (old) old.remove();
      if (focus) { var hq = $('.hp-step[data-step="' + step + '"] .hp-q', form); if (hq) hq.focus({ preventScroll: true }); bringIntoView(o.flow); }
    }
    wide.addEventListener('change', render);
    return { show: show, render: render, cur: function () { return cur; } };
  }

  /* ====================== CONTACT ====================== */
  function contact() {
    var form = $('#cf'); if (!form) return;
    var flow = $('[data-flow]'), nav = $('[data-prog]'), card = $('[data-card]'), done = $('[data-done]');
    var TOPICS = CFG.topics || {}, R = CFG.review || {};
    var PANEL = { order: 1, damaged: 1, idea: 1, wholesale: 1, creator: 1 };
    var opened = Date.now(), sending = false, st;
    form.noValidate = true;
    $$('.hp-nojs-details input, .hp-nojs-details textarea', form).forEach(function (i) { i.disabled = true; });

    function topic() { var r = form.querySelector('input[name="contact[Topic]"]:checked'); return r ? r.value : ''; }
    function panel() { var t = topic(); return t && PANEL[t] ? $('[data-topic-panel="' + t + '"]', form) : null; }
    function list() { var s = ['topic']; if (!topic() || panel()) s.push('details'); return s.concat(['message', 'you', 'review']); }
    function pv(id) { var el = $(id, form); return el ? el.value.trim() : ''; }
    function fieldValue(f) { var r = f.querySelector('input[type=radio]:checked'); if (f.querySelector('input[type=radio]')) return r ? r.value : ''; var i = f.querySelector('input, textarea'); return i ? i.value.trim() : ''; }
    function detailRows() {
      var p = panel(); if (!p) return [];
      return $$('[data-label]', p).map(function (f) { return [f.getAttribute('data-label'), fieldValue(f)]; }).filter(function (r) { return r[1]; });
    }
    function answers() {
      var a = {}, t = topic();
      if (t) a.topic = TOPICS[t] || t;
      var d = detailRows().map(function (r) { return r[1]; });
      if (d.length) a.details = d.join(', ');
      var m = pv('#c-msg'); if (m) a.message = m.length > 34 ? m.slice(0, 32).trim() + '…' : m;
      var nm = pv('#c-name'); if (nm) a.you = nm;
      return a;
    }
    function enablePanel() {
      var p = panel();
      $$('[data-topic-panel]', form).forEach(function (x) {
        $$('input, textarea', x).forEach(function (i) { i.disabled = x !== p; });
      });
    }
    function onShow(step) {
      if (step === 'details') {
        var p = panel();
        $$('[data-topic-panel]', form).forEach(function (x) { x.hidden = x !== p; });
        $('[data-details-title]', form).textContent = p.getAttribute('data-title');
        var h = $('[data-details-hint]', form), hint = p.getAttribute('data-hint') || ''; h.textContent = hint; h.hidden = !hint;
      }
      if (step === 'review') buildReview();
    }
    st = stepper({ form: form, flow: flow, nav: nav, list: list, answers: answers, onShow: onShow, first: 'topic' });
    function onTopic() {
      var t = topic();
      $$('[data-note]', form).forEach(function (n) { n.hidden = n.getAttribute('data-note') !== t; });
      var next = $('.hp-step[data-step="topic"] [data-next]', form);
      if (t === 'return') { next.className = 'jh-btn jh-btn--secondary'; next.textContent = next.getAttribute('data-label-return'); }
      else if (t === 'sizes') { next.className = 'jh-btn jh-btn--primary'; next.textContent = next.getAttribute('data-label-sizes'); }
      else { next.className = 'jh-btn jh-btn--primary'; next.textContent = next.getAttribute('data-label-default'); }
      enablePanel();
      st.render();
    }
    function buildReview() {
      var rows = [[R.topic, TOPICS[topic()] || '', 'topic']];
      detailRows().forEach(function (r) { rows.push([r[0], r[1], 'details']); });
      rows.push([R.message, pv('#c-msg'), 'message', true], [R.name, pv('#c-name'), 'you'], [R.email, pv('#c-email'), 'you']);
      $('[data-review]', form).innerHTML = rows.map(function (r) {
        return '<div class="hp-review__row"><dt>' + esc(r[0]) + '</dt><dd' + (r[3] ? ' class="hp-review__msg"' : '') + '>' + esc(r[1]) + '</dd><button type="button" class="hp-review__chg" data-goto="' + r[2] + '">' + esc(R.change) + '<span class="hp-vh"> ' + esc(String(r[0]).toLowerCase()) + '</span></button></div>';
      }).join('');
      $$('[data-goto]', form).forEach(function (b) { b.addEventListener('click', function () { st.show(b.getAttribute('data-goto'), true); }); });
    }
    function showDone() {
      form.hidden = true; nav.hidden = true; done.hidden = false; card.classList.add('is-done');
      var sp = $('[data-done-reply]', done);
      if (sp) sp.innerHTML = fill(T.done, { email: '<b data-done-email>' + esc(pv('#c-email')) + '</b>' });
      $('#done-h').focus({ preventScroll: true }); bringIntoView(flow);
    }
    function sendAlert(html) { var slot = $('[data-send-alert]', form); slot.innerHTML = html; if (slot.firstChild) slot.firstChild.setAttribute('tabindex', '-1'); if (slot.firstChild) slot.firstChild.focus({ preventScroll: true }); }
    function send() {
      var btn = $('[data-send]', form), busy = $('.hp-step[data-step="review"] [data-busy]', form);
      if (sending) return;
      sending = true; setBusy(btn, busy, true); $('[data-send-alert]', form).innerHTML = '';
      var ans = {}, n = 0;
      detailRows().forEach(function (r) { if (n < 12) { ans[String(r[0]).slice(0, 40)] = r[1].slice(0, 300); n++; } });
      var t = topic();
      post(CFG.endpoint, { topic: t, subject: TOPICS[t] || '', body: pv('#c-msg'), name: pv('#c-name'), email: pv('#c-email'), answers: ans, jc_hp: ($('#c-hp', form) || {}).value || '', dwellMs: Date.now() - opened })
        .then(function (r) {
          sending = false; setBusy(btn, busy, false);
          if (r.ok && r.j && r.j.ok) { showDone(); return; }
          if (r.status === 429) { sendAlert(alertBox('error', T.limitTitle, fill(T.limitBody, { mail: mailLink() }))); return; }
          var body = r.status === 400 && r.j && r.j.error ? esc(r.j.error) : fill(T.failedBody, { mail: mailLink() });
          sendAlert(alertBox('error', T.failedTitle, body));
        })
        .catch(function () { sending = false; setBusy(btn, busy, false); sendAlert(alertBox('error', T.failedTitle, fill(T.failedBody, { mail: mailLink() }))); });
    }
    form.addEventListener('change', function (e) { if (e.target.name === 'contact[Topic]') onTopic(); });
    form.addEventListener('click', function (e) {
      var b = e.target.closest('[data-next], [data-back]'); if (!b) return;
      var l = list(), k = l.indexOf(st.cur());
      if (b.hasAttribute('data-back')) { if (k > 0) st.show(l[k - 1], true); return; }
      if (validate($('.hp-step[data-step="' + st.cur() + '"]', form))) st.show(l[k + 1], true);
    });
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var l = list();
      if (st.cur() !== 'review') { if (validate($('.hp-step[data-step="' + st.cur() + '"]', form))) st.show(l[l.indexOf(st.cur()) + 1], true); return; }
      send();
    });
    var again = $('[data-again]', done);
    if (again) again.addEventListener('click', function () {
      var keepN = pv('#c-name'), keepE = pv('#c-email');
      form.reset(); $('#c-name').value = keepN; $('#c-email').value = keepE;
      done.hidden = true; form.hidden = false; nav.hidden = false; card.classList.remove('is-done');
      opened = Date.now(); onTopic(); st.show('topic', true);
    });
    // nothing is preselected; a back/forward restore may bring answers back, so read them
    onTopic(); st.show('topic');
    flow.classList.add('is-ready');
  }

  /* ====================== TRACK ====================== */
  function track() {
    var form = $('#tf'); if (!form) return;
    var res = $('[data-res]'), empty = $('[data-empty]'), status = $('[data-status]');
    var btn = $('[data-submit]', form), busy = $('[data-busy]', form), working = false;
    var STAGE_ICONS = ['box', 'print', 'ship', 'home'];
    var STAGE_OF = { placed: 0, in_production: 1, shipped: 2, partial: 2, delivered: 3, returned: 2, needs_check: 1 };
    var STATE_OF = { placed: 'placed', in_production: 'in_production', shipped: 'shipped', partial: 'partial', delivered: 'delivered', cancelled: 'cancelled', refunded: 'refunded', needs_check: 'needs_check' };
    var SHOWS_WINDOW = { placed: 1, in_production: 1, shipped: 1, partial: 1 };
    var TONE = { returned: 'warn', needs_check: 'warn', cancelled: 'muted', refunded: 'muted' };
    var ICON = { placed: 'box', in_production: 'print', shipped: 'ship', partial: 'ship', delivered: 'home', returned: 'return', needs_check: 'warn', cancelled: 'cancel', refunded: 'euro' };
    function links() {
      return { contact: '<a class="hp-link" href="' + esc(T.contactUrl) + '">' + esc(T.contactLink) + '</a>', withdraw: '<a class="hp-link" href="' + esc(T.withdrawUrl) + '">' + esc(T.withdrawLink) + '</a>', mail: mailLink() };
    }
    function httpsUrl(u) { return typeof u === 'string' && /^https:\/\//i.test(u) ? u : ''; }
    function stagesHTML(stage, stuck, stuckText) {
      return '<ol class="hp-stages" aria-label="' + esc(T.stagesLabel) + '" role="list">' + T.stages.map(function (g, k) {
        var s = k < stage ? 'done' : (k === stage ? 'now' : 'next');
        var isStuck = s === 'now' && stuck;
        var dot = s === 'done' ? icon('check') : icon(isStuck ? 'warn' : STAGE_ICONS[k]);
        var tag = s === 'now' ? '<span class="hp-stages__tag' + (isStuck ? ' is-stuck' : '') + '">' + esc(isStuck ? stuckText : T.stageNow) + '</span>' : '';
        var sr = s === 'done' ? '<span class="hp-vh">, ' + esc(T.stageDone) + '</span>' : (s === 'next' ? '<span class="hp-vh">, ' + esc(T.stageNext) + '</span>' : '');
        return '<li class="is-' + s + (isStuck ? ' is-stuck' : '') + '"' + (s === 'now' ? ' aria-current="step"' : '') + '><span class="hp-stages__dot" aria-hidden="true">' + dot + '</span><span class="hp-stages__t">' + esc(g[0]) + sr + '</span><span class="hp-stages__d">' + esc(g[1]) + '</span>' + tag + '</li>';
      }).join('') + '</ol>';
    }
    function estimate(w) {
      if (!w || !w.min || !w.max) return '';
      function d(s) { var p = String(s).split('-'); return new Date(Date.UTC(+p[0], +p[1] - 1, +p[2])); }
      var a = d(w.min), b = d(w.max); if (isNaN(a) || isNaN(b)) return '';
      var day = function (x) { return x.toLocaleDateString('en-GB', { day: 'numeric', timeZone: 'UTC' }); };
      var full = function (x) { return x.toLocaleDateString('en-GB', { day: 'numeric', month: 'long', timeZone: 'UTC' }); };
      if (w.min === w.max) return full(b);
      if (a.getUTCMonth() === b.getUTCMonth()) return day(a) + ' to ' + full(b);
      return full(a) + ' to ' + full(b);
    }
    function itemsHTML(f) {
      var items = (f.line_items || []).map(function (li) {
        var t = li && li.title ? li.title : T.itemFallback;
        return '<li><span class="tr-items__t">' + esc(t) + (li && li.quantity > 1 ? ' (' + esc(li.quantity) + ')' : '') + '</span></li>';
      }).join('');
      return items ? '<ul class="tr-items" role="list">' + items + '</ul>' : '';
    }
    function parcelHTML(f, k, n, key, carrierStatus) {
      var tr = f.tracking && f.tracking.number ? f.tracking : null;
      var stText = f.status === 'delivered' ? T.parcelDelivered : (key === 'returned' ? T.parcelReturning : (carrierStatus === 'in_transit' ? T.parcelTransit : T.parcelShipped));
      var carrier = tr ? (tr.company || T.carrierFallback) : '';
      var trk;
      if (tr) {
        var u = httpsUrl(tr.url);
        trk = '<div class="tr-carrier"><p class="tr-carrier__k">' + esc(plain(T.trackingNumber, { carrier: carrier })) + ' <span class="tr-num" translate="no">' + esc(tr.number) + '</span></p>' +
          (u ? '<a class="jh-btn jh-btn--secondary tr-carrier__go" href="' + esc(u) + '" target="_blank" rel="noopener noreferrer">' + esc(plain(T.trackWith, { carrier: carrier })) + icon('external') + '<span class="hp-vh"> (' + esc(T.newTab) + ')</span></a>' : '') + '</div>';
      } else if (f.status === 'delivered') trk = '';
      else trk = '<p class="hp-hint tr-carrier__none">' + icon('clock') + '<span>' + esc(T.noTracking) + '</span></p>';
      var title = n > 1 ? plain(T.parcelN, { k: k + 1, n: n }) : T.parcelOne;
      return '<section class="tr-parcel" aria-label="' + esc(title) + '"><p class="tr-parcel__h"><span>' + esc(title) + '</span><span class="tr-parcel__st">' + icon(f.status === 'delivered' ? 'check' : 'ship') + esc(stText) + '</span></p>' + itemsHTML(f) + trk + '</section>';
    }
    function winHTML(data) {
      var est = estimate(data.estimated_delivery), W = CFG.window || {};
      var num = est || W.days, lab = est ? W.estLabel : W.label;
      if (!num) return '';
      return '<div class="tr-window hp-fig"><span class="hp-ring" aria-hidden="true">' + icon('ship') + '</span><span class="hp-fig__num">' + esc(num) + '</span><span class="hp-fig__lab">' + esc(lab) + '</span></div>';
    }
    function render(data) {
      var raw = String(data.state || '');
      var key = STATE_OF[raw] || 'needs_check';
      if (data.carrier_status === 'returned' && (key === 'shipped' || key === 'partial')) key = 'returned';
      var fulf = Array.isArray(data.fulfillments) ? data.fulfillments : [];
      var L = links(), S = T.state[key];
      var fig = key === 'partial' ? (fulf.length > 1 ? plain(S[0], { n: fulf.length }) : 'Part of your order is on its way') : S[0];
      var placed = data.placed_at ? new Date(data.placed_at) : null;
      var sub = placed && !isNaN(placed) ? '<p class="tr-sub">' + esc(plain(T.placedOn, { date: new Intl.DateTimeFormat('en-GB', { day: 'numeric', month: 'long', year: 'numeric' }).format(placed) })) + '</p>' : '';
      var head = '<div class="tr-head"><span class="tr-ring" aria-hidden="true">' + icon(ICON[key]) + '</span><div class="tr-head__txt"><h2 class="tr-h" id="tr-h" tabindex="-1">' + esc(plain(T.order, { n: String(data.order_number || '').replace(/^#/, '') })) + '</h2>' + sub + '</div></div>';
      var stage = STAGE_OF[key];
      var stuck = key === 'returned' ? T.stuckComing : (key === 'needs_check' ? T.stuckCheck : '');
      var cta = key === 'needs_check' ? '<p class="tr-cta"><a class="jh-btn jh-btn--secondary" href="' + esc(T.contactUrl) + '">' + icon('mail') + esc(T.checkButton) + '</a></p>' : '';
      var parcels = '';
      if ((key === 'shipped' || key === 'partial' || key === 'delivered' || key === 'returned') && fulf.length) {
        parcels = '<div class="tr-parcels">' + fulf.map(function (f, k) { return parcelHTML(f, k, fulf.length, key, data.carrier_status); }).join('') + '</div>';
      }
      var detail = (SHOWS_WINDOW[key] ? winHTML(data) : '') + parcels;
      res.innerHTML = '<div class="tr-card tr--' + (TONE[key] || 'ok') + '">' + head + '<p class="tr-fig">' + esc(fig) + '</p><p class="tr-msg">' + fill(S[1], L) + '</p>' + cta +
        (stage != null ? stagesHTML(stage, !!stuck, stuck) : '') + (detail ? '<div class="tr-detail">' + detail + '</div>' : '') + '</div>';
      res.hidden = false; empty.hidden = true;
      var h = $('#tr-h'); if (h) h.focus({ preventScroll: true });
      bringIntoView(res);
    }
    function formMsg(kind) {
      var M = { bad: T.errBad, notfound: T.errNotFound, limit: T.errLimit, net: T.errNet }[kind];
      status.innerHTML = M ? alertBox('error', M[0], fill(M[1], { mail: mailLink() })) : '';
    }
    try {
      var pre = String(new URLSearchParams(location.search).get('order') || '').replace(/[^0-9]/g, '');
      if (pre && pre.length <= 12) { $('#t-ord').value = '#' + pre; $('#t-email').focus(); }
    } catch (e) { /* no prefill */ }
    form.addEventListener('submit', function (e) {
      e.preventDefault(); formMsg('');
      if (working) return;
      if (!validate(form)) return;
      working = true; setBusy(btn, busy, true);
      post(CFG.endpoint, { order_number: $('#t-ord').value.trim(), email: $('#t-email').value.trim() })
        .then(function (r) {
          working = false; setBusy(btn, busy, false);
          if (r.ok && r.j && r.j.ok) { render(r.j); return; }
          res.hidden = true; empty.hidden = false;
          formMsg(r.status === 400 ? 'bad' : (r.status === 404 ? 'notfound' : (r.status === 429 ? 'limit' : 'net')));
        })
        .catch(function () { working = false; setBusy(btn, busy, false); res.hidden = true; empty.hidden = false; formMsg('net'); });
    });
  }

  /* ====================== WITHDRAW ====================== */
  function withdraw() {
    var form = $('#wf'); if (!form) return;
    var flow = $('[data-flow]'), nav = $('[data-prog]'), card = $('[data-card]'), done = $('[data-done]');
    var LIST = ['order', 'details', 'review'], R = T.row || {};
    var sending = false, matched = null, matchInfo = null, st;
    form.noValidate = true;
    function v(id) { var el = $(id, form); return el ? el.value.trim() : ''; }
    function scope() { var r = form.querySelector('input[name="scope"]:checked'); return r ? r.value : ''; }
    function ordNo() { return v('#w-ord').replace(/^[#\s]+/, ''); }
    function scopeText() { return scope() === 'part' ? T.scopePart : (scope() === 'whole' ? T.scopeWhole : ''); }
    function answers() { var a = {}; if (v('#w-ord')) a.order = '#' + ordNo(); if (v('#w-name')) a.details = v('#w-name'); return a; }
    function rows() {
      var r = [[R.order, '#' + ordNo(), 'order'], [R.email, v('#w-email'), 'order'], [R.name, v('#w-name'), 'details'], [R.scope, scopeText(), 'details']];
      if (scope() === 'part' && v('#w-which')) r.push([R.note, v('#w-which'), 'details']);
      return r;
    }
    function onScope() { $('[data-which]', form).hidden = scope() !== 'part'; }
    st = stepper({ form: form, flow: flow, nav: nav, list: function () { return LIST; }, answers: answers, first: 'order', onShow: function (s) { if (s === 'review') buildReview(); } });
    function buildReview() {
      var m = $('[data-match]', form);
      if (matched === true && matchInfo) {
        var items = (matchInfo.items || []).map(function (i) { return i.title + (i.quantity > 1 ? ' (' + i.quantity + ')' : ''); }).join(', ');
        m.innerHTML = alertBox('info', T.matchTitle, esc(plain(T.matchBody, { order: String(matchInfo.number || ordNo()).replace(/^#/, ''), date: matchInfo.placed_at ? fmtDate(matchInfo.placed_at) : '', items: items })));
      } else if (matched === false) m.innerHTML = alertBox('info', T.noMatchTitle, esc(T.noMatchBody));
      else m.innerHTML = '';
      if (m.firstChild) m.firstChild.setAttribute('role', 'note');
      $('[data-review]', form).innerHTML = rows().map(function (r) {
        return '<div class="hp-review__row"><dt>' + esc(r[0]) + '</dt><dd>' + esc(r[1]) + '</dd><button type="button" class="hp-review__chg" data-goto="' + r[2] + '">' + esc(R.change) + '<span class="hp-vh"> ' + esc(String(r[0]).toLowerCase()) + '</span></button></div>';
      }).join('');
      $$('[data-goto]', form).forEach(function (b) { b.addEventListener('click', function () { st.show(b.getAttribute('data-goto'), true); }); });
    }
    function sendAlert(html) { var slot = $('[data-send-alert]', form); slot.innerHTML = html; if (slot.firstChild) { slot.firstChild.setAttribute('tabindex', '-1'); slot.firstChild.focus({ preventScroll: true }); } }
    function body(step) {
      return { step: step, path: 'guest', order_number: ordNo(), name: v('#w-name'), email: v('#w-email'), scope: scope() || 'whole', note: scope() === 'part' ? v('#w-which') : '', jw_hp: ($('#w-hp', form) || {}).value || '' };
    }
    function fieldProblem(field, message) {
      var map = { order_number: ['order', '#w-ord-f'], email: ['order', '#w-email-f'], name: ['details', '#w-name-f'], order: ['order', '#w-ord-f'] }, m = map[field];
      if (!m) return false;
      st.show(m[0], false);
      var f = $(m[1], form); f.setAttribute('data-err-now', message); setErr(f, message);
      errSummary($('.hp-step[data-step="' + m[0] + '"] .hp-step__body', form), [f]);
      var c = firstCtrl(f); if (c) c.focus();
      return true;
    }
    /* step 2 to 3: ask the Worker whether the order is there, so the check page can say so */
    function check(nextBtn) {
      var busy = $('[data-busy-check]', form);
      if (sending) return;
      sending = true; setBusy(nextBtn, busy, true);
      post(CFG.endpoint, body('check'))
        .then(function (r) {
          sending = false; setBusy(nextBtn, busy, false);
          if (r.status === 429) { sendAlertDetails(alertBox('error', T.limitTitle, esc(T.limitBody))); return; }
          if (r.status === 400 && r.j) {
            if (fieldProblem(r.j.field, r.j.message || '')) return;
            sendAlertDetails(alertBox('error', T.checkTitle, esc(r.j.message || T.checkBody)));
            return;
          }
          matched = r.ok && r.j && r.j.ok ? !!r.j.matched : null;
          matchInfo = matched ? r.j.order : null;
          st.show('review', true);
        })
        .catch(function () { sending = false; setBusy(nextBtn, busy, false); matched = null; matchInfo = null; st.show('review', true); });
    }
    function sendAlertDetails(html) {
      var b = $('.hp-step[data-step="details"] .hp-step__body', form), old = b.querySelector('.hp-alert'); if (old) old.remove();
      var d = document.createElement('div'); d.innerHTML = html; b.insertBefore(d.firstChild, b.firstChild); b.firstChild.setAttribute('tabindex', '-1'); b.firstChild.focus({ preventScroll: true });
    }
    function showDone(j, submitted) {
      form.hidden = true; nav.hidden = true; done.hidden = false; card.classList.add('is-done');
      var when = j.submitted_at || j.received_at;
      var r = [[R.received, fmtDate(when, true) + ' ' + (T.lisbon || '')]].concat(submitted);
      $('[data-r-ref]', done).textContent = j.reference || '';
      $('[data-receipt]', done).innerHTML = r.map(function (x) { return '<div class="hp-review__row"><dt>' + esc(x[0]) + '</dt><dd>' + esc(x[1]) + '</dd></div>'; }).join('');
      var next = [], ok = j.matched !== false;
      next.push(j.email_sent === false ? ['warn', esc(T.mailNotSent)] : ['mail', fill(T.mailSent, { email: '<b>' + esc(submittedEmail) + '</b>' })]);
      next.push(ok ? ['return', esc(T.nextMatched)] : ['search', esc(T.nextUnmatched)]);
      next.push(['euro', esc(T.refund)]);
      $('[data-next-list]', done).innerHTML = next.map(function (n) { return '<li>' + icon(n[0] === 'search' ? 'info' : n[0]) + '<span>' + n[1] + '</span></li>'; }).join('');
      $('[data-dup]', done).innerHTML = j.duplicate || j.repeat ? alertBox('info', T.dupTitle, esc(plain(T.dupBody, { date: fmtDate(when), time: fmtTime(when) }))) : '';
      $('#done-h').focus({ preventScroll: true }); bringIntoView(flow);
    }
    var submittedEmail = '';
    function send() {
      if (sending) return;
      var btn = $('[data-send]', form), busy = $('.hp-step[data-step="review"] [data-busy]', form);
      sending = true; setBusy(btn, busy, true); $('[data-send-alert]', form).innerHTML = '';
      var snapshot = rows().map(function (x) { return [x[0], x[1]]; });
      submittedEmail = v('#w-email');
      post(CFG.endpoint, body('confirm'))
        .then(function (r) {
          sending = false; setBusy(btn, busy, false);
          if (r.ok && r.j && r.j.ok) { showDone(r.j, snapshot); return; }
          if (r.status === 429) { sendAlert(alertBox('error', T.limitTitle, esc(T.limitBody))); return; }
          if (r.status === 400 && r.j && fieldProblem(r.j.field, r.j.message || '')) return;
          if (r.j && r.j.error === 'not_recorded') { sendAlert(alertBox('error', T.notRecordedTitle, fill(T.notRecordedBody, { mail: mailLink() }))); return; }
          sendAlert(alertBox('error', T.notRecordedTitle, fill(T.notRecordedBody, { mail: mailLink() })));
        })
        .catch(function () { sending = false; setBusy(btn, busy, false); sendAlert(alertBox('error', T.networkTitle, fill(T.networkBody, { mail: mailLink() }))); });
    }
    form.addEventListener('change', function (e) { if (e.target.name === 'scope') onScope(); });
    form.addEventListener('click', function (e) {
      var b = e.target.closest('[data-next], [data-back]'); if (!b) return;
      var k = LIST.indexOf(st.cur());
      if (b.hasAttribute('data-back')) { if (k > 0) st.show(LIST[k - 1], true); return; }
      if (b.getAttribute('aria-disabled') === 'true') return;
      var sec = $('.hp-step[data-step="' + st.cur() + '"]', form);
      if (!validateWithScope(sec)) return;
      if (st.cur() === 'details') check(b); else st.show(LIST[k + 1], true);
    });
    function validateWithScope(sec) {
      var which = $('#w-which-f', form), need = sec.contains(which) && scope() === 'part';
      if (need) { which.setAttribute('data-req', ''); which.setAttribute('data-err', T.whichError); } else which.removeAttribute('data-req');
      return validate(sec);
    }
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (st.cur() !== 'review') { var k = LIST.indexOf(st.cur()); if (validateWithScope($('.hp-step[data-step="' + st.cur() + '"]', form))) { if (st.cur() === 'details') check($('.hp-step[data-step="details"] [data-next]', form)); else st.show(LIST[k + 1], true); } return; }
      send();
    });
    var pr = $('[data-print]', done); if (pr) pr.addEventListener('click', function () { window.print(); });
    onScope(); st.show('order');
    flow.classList.add('is-ready');
  }

  if (PAGE === 'contact') contact();
  if (PAGE === 'track') track();
  if (PAGE === 'withdraw') withdraw();
})();
